export const storageKeys = {
  token: "athome_customer_token",
  userInfo: "athome_customer_user_info",
  location: "athome_customer_location",
  city: "athome_customer_city",
  couponPackagePopup: "athome_customer_coupon_package_popup",
} as const;

export const storage = {
  get<T>(key: string): T | null {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  },

  set(key: string, value: unknown) {
    window.localStorage.setItem(key, JSON.stringify(value));
  },

  remove(key: string) {
    window.localStorage.removeItem(key);
  },
};
